/** Gmail two-way sync: inbox replies + sent mail with this lead, pulled from agents' connected Gmail. */
import React, { useEffect, useState } from 'react';
import { ArrowDownLeft, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import api from '../../lib/api';

export function SyncedEmails({ leadId }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.request(`/leads/${leadId}/synced-emails`).then((d) => setRows(d.messages)).catch(() => {}); }, [leadId]);
  if (!rows.length) return null;
  return (
    <div className="mb-6 space-y-2" data-testid="synced-emails">
      <p className="text-sm font-semibold">From Gmail <span className="font-normal text-muted-foreground">· {rows.length} synced</span></p>
      {rows.map((m) => (
        <div key={m.gmail_id} className="rounded-lg border p-3 text-sm" data-testid={`synced-email-${m.gmail_id}`}>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            {m.direction === 'INBOUND' ? <ArrowDownLeft className="h-3.5 w-3.5 text-emerald-600" /> : <ArrowUpRight className="h-3.5 w-3.5 text-sky-600" />}
            <span>{m.direction === 'INBOUND' ? `From ${m.from}` : `To ${m.to}`}</span><span className="ml-auto">{m.sent_at ? new Date(m.sent_at).toLocaleString() : ''}</span>
          </div>
          <p className="mt-1 font-medium">{m.subject || '(no subject)'}</p><p className="text-xs text-muted-foreground">{m.snippet}</p>
          {m.coachable && <Link to={`/reply-coach?m=${m.gmail_id}`} className="mt-2 inline-block text-xs font-medium text-primary underline" data-testid={`coach-link-${m.gmail_id}`}>Coach this reply</Link>}
        </div>))}
    </div>
  );
}

export function GmailSyncButton() {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const run = async () => {
    setBusy(true);
    try {
      const r = await api.request('/me/gmail-sync', { method: 'POST' });
      const stored = r.results.reduce((n, x) => n + (x.stored || 0), 0);
      const reconnect = r.results.some((x) => x.status === 'RECONNECT_NEEDED');
      setMsg(!r.accounts ? 'Connect Gmail first.' : reconnect ? 'Gmail needs to be reconnected.' : `${stored} new message${stored === 1 ? '' : 's'} linked to your leads.`);
    } catch (e) { setMsg(e.message || 'Sync failed'); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-3 text-sm" data-testid="gmail-sync">
      <button type="button" onClick={run} disabled={busy} className="rounded-full border px-4 py-1.5 hover:bg-muted disabled:opacity-50" data-testid="gmail-sync-btn">{busy ? 'Syncing…' : 'Sync Gmail now'}</button>
      <span className="text-xs text-muted-foreground" data-testid="gmail-sync-result">{msg || 'Inbox replies and sent mail with your leads sync every 15 minutes. A reply stops that contact\'s campaigns.'}</span>
    </div>
  );
}
